// extracted by mini-css-extract-plugin
export default {"container":"input-with-buttons_container__z2y6X","text_field":"input-with-buttons_text_field__BNEU0","buttons":"input-with-buttons_buttons__BZ0Nn"};